import { Pagination } from './Pagination';
import { Zoom } from './Zoom';
import { Container, LeftContainer, MiddleContainer, RightContainer } from './styled';
export function Toolbar(props) {
    const { zoom, zoomTo } = props;
    return (<Container>
      <LeftContainer>
        <Zoom zoom={zoom} zoomTo={zoomTo}/>
      </LeftContainer>
      <MiddleContainer />
      <RightContainer>
        <Pagination />
      </RightContainer>
    </Container>);
}
